(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  var EFECTOS = {
    fondo: 'kvhd-efecto-fondo',
    subrayado: 'kvhd-efecto-subrayado',
    subrayado_animado: 'kvhd-efecto-subrayado-animado'
  };

  function abrirCarritoTema() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }
    var burbuja = document.querySelector('#cart-icon-bubble, .header__icon--cart');
    if (drawer && burbuja) {
      burbuja.click();
      return true;
    }
    return false;
  }

  function iniciarCajon(raiz) {
    var envoltorio = document.getElementById('kvhd-cajon-' + raiz.dataset.kvhdId);
    if (!envoltorio) return null;
    if (envoltorio.parentNode !== document.body) {
      document.body.appendChild(envoltorio);
    }
    envoltorio.removeAttribute('hidden');

    function abrir() {
      envoltorio.classList.add('kvhd-cajon-activo');
      document.body.classList.add('kvhd-sin-scroll');
      raiz.querySelectorAll('[data-kvhd-abrir]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'true');
      });
    }

    function cerrar() {
      envoltorio.classList.remove('kvhd-cajon-activo');
      document.body.classList.remove('kvhd-sin-scroll');
      raiz.querySelectorAll('[data-kvhd-abrir]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
    }

    raiz.querySelectorAll('[data-kvhd-abrir]').forEach(function (boton) {
      boton.addEventListener('click', function (e) {
        e.preventDefault();
        abrir();
      });
    });

    envoltorio.querySelectorAll('[data-kvhd-cerrar]').forEach(function (boton) {
      boton.addEventListener('click', function (e) {
        e.preventDefault();
        cerrar();
      });
    });

    envoltorio.querySelectorAll('[data-kvhd-acordeon]').forEach(function (boton) {
      boton.addEventListener('click', function (e) {
        e.preventDefault();
        var item = boton.closest('.kvhd-item-cajon');
        if (!item) return;
        var abierto = item.classList.contains('kvhd-acordeon-abierto');
        item.classList.toggle('kvhd-acordeon-abierto', !abierto);
        boton.setAttribute('aria-expanded', abierto ? 'false' : 'true');
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') cerrar();
    });

    return { envoltorio: envoltorio, cerrar: cerrar };
  }

  function iniciarBusqueda(raiz) {
    var panel = raiz.querySelector('[data-kvhd-panel]');
    if (!panel) return;
    var botones = raiz.querySelectorAll('[data-kvhd-buscar]');
    botones.forEach(function (boton) {
      boton.addEventListener('click', function (e) {
        e.preventDefault();
        var abierto = panel.classList.toggle('kvhd-panel-abierto');
        if (abierto) {
          var campo = panel.querySelector('.kvhd-campo-busqueda');
          if (campo) setTimeout(function () { campo.focus(); }, 120);
        }
      });
    });
    document.addEventListener('click', function (e) {
      if (!panel.classList.contains('kvhd-panel-abierto')) return;
      if (panel.contains(e.target)) return;
      if (e.target.closest && e.target.closest('[data-kvhd-buscar]')) return;
      panel.classList.remove('kvhd-panel-abierto');
    });
  }

  function iniciarCarrito(raiz) {
    raiz.querySelectorAll('[data-kvhd-carrito]').forEach(function (enlace) {
      if (enlace.dataset.kvhdCarrito !== 'true') return;
      enlace.addEventListener('click', function (e) {
        if (abrirCarritoTema()) {
          e.preventDefault();
        }
      });
    });
  }

  function iniciarScroll(raiz) {
    var modo = raiz.dataset.comportamiento;
    var transparente = raiz.dataset.transparente === 'true';
    var sombra = raiz.dataset.sombraScroll === 'true';

    if (modo === 'normal' && !transparente && !sombra) return;

    var ultimo = window.pageYOffset;
    var pendiente = false;

    function actualizar() {
      var actual = window.pageYOffset;

      if (transparente) {
        raiz.classList.toggle('kvhd-solida', actual > 12);
      }

      if (sombra) {
        raiz.classList.toggle('kvhd-con-sombra', actual > 12);
      }

      if (modo === 'fijo_scroll_arriba') {
        if (actual > 180 && actual > ultimo) {
          raiz.classList.add('kvhd-flotante-oculto');
        } else {
          raiz.classList.remove('kvhd-flotante-oculto');
        }
      }

      ultimo = actual;
      pendiente = false;
    }

    window.addEventListener('scroll', function () {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(actualizar);
    }, { passive: true });

    actualizar();
  }

  function aplicarEfecto(raiz) {
    var efecto = raiz.dataset.efecto;
    if (efecto && EFECTOS[efecto]) {
      raiz.classList.add(EFECTOS[efecto]);
    }
  }

  function iniciar(raiz) {
    if (!raiz || raiz.dataset.kvhdIniciado === 'true') return;
    raiz.dataset.kvhdIniciado = 'true';
    aplicarEfecto(raiz);
    iniciarCajon(raiz);
    iniciarBusqueda(raiz);
    iniciarCarrito(raiz);
    iniciarScroll(raiz);
  }

  function iniciarTodos(contexto) {
    var ambito = contexto || document;
    ambito.querySelectorAll('.kvhd-seccion').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciarTodos(); });
  } else {
    iniciarTodos();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var viejos = document.querySelectorAll('body > .kvhd-envoltorio-cajon');
    viejos.forEach(function (el) {
      if (!document.getElementById(el.id.replace('kvhd-cajon-', 'kvhd-'))) {
        el.remove();
      }
    });
    iniciarTodos(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var raiz = e.target.querySelector('.kvhd-seccion');
    if (!raiz) return;
    var cajon = document.getElementById('kvhd-cajon-' + raiz.dataset.kvhdId);
    if (cajon) cajon.remove();
    document.body.classList.remove('kvhd-sin-scroll');
  });

  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest ? e.target.closest('.kvhd-item-menu') : null;
    if (item) {
      item.classList.add('kvhd-abierto');
      return;
    }
    var itemCajon = e.target.closest ? e.target.closest('.kvhd-item-cajon') : null;
    if (itemCajon) itemCajon.classList.add('kvhd-acordeon-abierto');
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    var item = e.target.closest ? e.target.closest('.kvhd-item-menu') : null;
    if (item) item.classList.remove('kvhd-abierto');
  });
})();

  } catch(e) { console.error(e); }
})();
})();
